module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/coolant_gauge_indicator_64_bake.png";